import { Text } from '@procurify/ui'
import styled from 'styled-components'

interface IAddressStyledProps {}

export const AddressStyled = styled(Text)<IAddressStyledProps>``
